import request from '@/utils/request'

export function getSortLists(sub_sort) {
  return request({
    url: '/api/?m=Uc&c=Index&a=get_sorts_list&sub_id='+sub_sort,
    method: 'get',
  })
}
export function getInforsLists(sub_sort) {
  return request({
    url: '/api/?m=Uc&c=Index&a=get_infors_list&sub_id='+sub_sort,
    method: 'get',
  })
}






// WEBPACK FOOTER //
// ./src/api/index.js